import type CelebrationsRow from "@travily/types/models/CelebrationsRow";
import type Community from "@travily/types/pending/models/Community";
import type { ReactNode } from "react";
import { Celebrations } from "@/components/Celebrations/Celebrations";
import { ProfileFrame } from "@/components/ProfileFrame/ProfileFrame";
import { communityProfileAccount } from "@/components/ProfileFrame/profile-account";
import type { ProfileTabHrefs } from "@/components/ProfileTabs/ProfileTabs";
import { type CommunityProgram, Programs } from "./components/Programs";

export interface ShowViewProps {
  banner?: ReactNode;
  celebrations: CelebrationsRow[];
  community: Community;
  restricted?: boolean;
  programs?: CommunityProgram[];
  /** Profile/store tab hrefs when the profile has a store. */
  tabs?: ProfileTabHrefs;
  onAddCelebration?: () => void;
  onAcceptFriendship?: () => void;
  onDeclineFriendship?: () => void;
  onFriendshipAction?: () => void;
  onShareProfile?: () => void;
  onUnfriend?: () => void;
  onViewFriends?: () => void;
}

export function ShowView({
  banner,
  celebrations,
  community,
  programs = [],
  onAcceptFriendship,
  onAddCelebration,
  onDeclineFriendship,
  restricted,
  onFriendshipAction,
  onShareProfile,
  onUnfriend,
  onViewFriends,
  tabs,
}: ShowViewProps) {
  return (
    <ProfileFrame
      account={communityProfileAccount(community)}
      currentTab="profile"
      onAcceptFriendship={onAcceptFriendship}
      onDeclineFriendship={onDeclineFriendship}
      onFriendshipAction={onFriendshipAction}
      onShareProfile={onShareProfile}
      onUnfriend={onUnfriend}
      onViewFriends={onViewFriends}
      restricted={restricted}
      tabs={tabs}
    >
      {banner && <div className="mt-4 w-full text-left lg:mt-10">{banner}</div>}
      <Programs communityDisplayName={community.display_name} owner={community.can.edit} programs={programs} />
      <Celebrations
        celebrations={celebrations}
        onAddCelebration={onAddCelebration}
        ownerDisplayName={community.display_name}
      />
    </ProfileFrame>
  );
}
